export default function (ratings) {
    if (ratings.length === 0) {
        return null;
    }
    if (ratings.length === 1) {
        return ratings[0];
    }

    const combinedRatings = {};

    for (const r of ratings) {
        for (const ratingType in r) {
            const nr = r[ratingType]; // New Rating

            if (!combinedRatings[ratingType]) {
                combinedRatings[ratingType] = {
                    // @TODO distribution
                    ratingAverage: nr.ratingAverage,
                    ratingCount: nr.ratingCount,
                };
            } else {
                const cr = combinedRatings[ratingType]; // Combined Rating
                const totalRatingCount = nr.ratingCount + cr.ratingCount;

                cr.ratingAverage = ((cr.ratingAverage * cr.ratingCount) + (nr.ratingAverage * nr.ratingCount)) / totalRatingCount;
                cr.ratingCount = totalRatingCount;
            }
        }
    }

    return combinedRatings;
}
